import styled from 'styled-components';
import { mediaQuery, modalTitleHeight, paddings, zAbove } from '~/styled';

export const ModalContentTitleDiv = styled.div<{
  $infoOrErrorOrWarning: boolean;
  $center?: boolean;
  $bottomBorder?: boolean;
  $hasHeaderAction: boolean;
}>`
  height: ${modalTitleHeight};
  min-height: ${modalTitleHeight};
  display: flex;
  align-items: center;
  color: var(--on-surface);
  flex-direction: row;
  justify-content: ${({ $infoOrErrorOrWarning }) =>
    $infoOrErrorOrWarning ? 'flex-start' : 'center'};
  border-bottom: ${({ $bottomBorder, theme }) =>
    $bottomBorder ? `1px solid  ${theme.colors.grey200}` : 'none'};
  word-break: break-word;
  width: 100%;
  position: relative;
  padding: 0 ${paddings.defaultPadding};
  h2 {
    max-width: 100%;
    min-width: 0;
    flex-grow: 1;
    flex-basis: 0;
    padding-left: 16px;
    padding-right: ${({ $center, $hasHeaderAction }) =>
      $hasHeaderAction && !$center
        ? `calc(${paddings.hugePadding} + ${paddings.hugePadding} + ${paddings.hugePadding})`
        : '0'};
    overflow: hidden;
    text-align: ${({ $center }) => ($center ? 'center' : 'left')};
  }
  ${mediaQuery.up.s`
    padding: 0 ${paddings.medium2xPadding};
    padding: 0 ${paddings.largePadding};
    h2{
      font-weight: 700;
      font-size: 20px;
      line-height: 1;
      align-items: center;
      display: flex;
      justify-content: ${({ $center }) => ($center ? 'center' : 'flex-start')};
      }
   `}

  ${mediaQuery.down.s`
    h2 {
      /* The mobile header action participates in flex layout, so it already reserves
         its own width and does not need the desktop overlay inset. */
      padding-right: 0;
    }
  `}

  ${({ $infoOrErrorOrWarning }) =>
    $infoOrErrorOrWarning &&
    mediaQuery.down.s`
        justify-content: flex-start;
        padding: 0 ${paddings.largePadding};
        h2{
          font-weight: 700;
          font-size: 20px;
          line-height: 24px;
          align-items: center;
          display: flex;
        }
    `}
`;

export const IconSpan = styled.span`
  margin-right: 16px;
  line-height: 24px;
  display: inline-block;
`;

export const CloseIcon = styled.div`
  float: right;
  position: absolute;
  top: 20px;
  right: 20px;
  cursor: pointer;
`;

export const HeaderActionDiv = styled.div`
  position: absolute;
  right: ${paddings.defaultPadding};
  top: 50%;
  transform: translateY(-50%);
  max-height: ${modalTitleHeight};
  z-index: ${zAbove};
  ${mediaQuery.up.s`
    right: ${paddings.medium2xPadding};
  `}
  ${mediaQuery.down.s`
    position:relative;
    right:unset;
    top:unset;
    transform:unset;
    margin-right:-${paddings.defaultPadding};
  `}
`;

export const OverFlowEclipsedSpan = styled.span`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 100%;
  display: inline-block;
  vertical-align: middle;
`;
